import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { PlaylistSfaDataProps } from './PlaylistSfaDataProps'
import { TableDate, Info } from './styles'

const PlaylistSfaData: FunctionComponent<PlaylistSfaDataProps> = ({
  playlistSfaData,
}) => {
  const { t } = useTranslation()

  const mappedPlaylistSfaData =
    playlistSfaData &&
    playlistSfaData.map(item => (
      <tr key={item.added_date}>
        <TableDate>{moment(item.added_date).format('l')}</TableDate>
        <Info>{item.listeners}</Info>
        <Info>{item.streams}</Info>{' '}
      </tr>
    ))

  return (
    <>
      {playlistSfaData && playlistSfaData.length > 0 ? (
        mappedPlaylistSfaData
      ) : (
        <tr>{t('adminPage.noSFAData')}</tr>
      )}
    </>
  )
}
export default PlaylistSfaData
